import {
  AdminCrudType,
  CustomAxiosType,
  DeleteAdmin,
  //PatchMemberImage,
  GetContactRecords,
  GetContactRecordsParams,
  GetMemberParams,
  GetMemberResult,
  GetMobListForAdminParams,
  MemberDetail,
  CustomAxiosSingleType,
  UserGroup,
  UserGroupParams,
  WebUpdate,
  CustomListType,
  DeviceInfo,
  SystemSetting,
} from "../types/types";
import { client } from "./client";
const b6t = `NB6T`;

// 사용자 조회
export const getMember = async ({
  page,
  searchKey,
  area,
  sort,
  limit,
}: GetMemberParams) => {
  const response = await client.post<CustomAxiosType<GetMemberResult>>(
    `/api/adminNB6T/member/get`,
    {
      page,
      searchKey,
      area,
      sort,
      limit,
    }
  );
  return response.data.result;
};

// 사용자 상세 조회
export const getMemberDetail = async ({ idx }: DeleteAdmin) => {
  const response = await client.post<CustomAxiosType<MemberDetail>>(
    `/api/admin` + b6t + `/member/detail`,
    {
      idx,
    }
  );
  return response.data.result;
};

// 사용자 삭제
export const deleteMember = async ({ idx }: DeleteAdmin) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/admin` + b6t + `/member/delete`,
    {
      idx,
    }
  );
  return response.data;
};

// 사용자 연락처 열람 기록 조회
export const getContactRecords = async ({
  area,
  page,
  startDate,
  endDate,
  searchKey,
  admin_idx,
  sort,
  limit,
}: GetContactRecordsParams) => {
  const response = await client.post<CustomAxiosType<GetContactRecords>>(
    `/api/admin` + b6t + `/contact`,
    {
      area,
      page,
      startDate,
      endDate,
      searchKey,
      admin_idx,
      sort,
      limit,
    }
  );
  return response.data.result;
};

// 사용자 계정 기기 조회
export const getMobileListForAdmin = async ({
  admin_idx,
  admin_name,
  mobility_code,
  page,
  searchKey = "",
  sort,
  limit,
}: GetMobListForAdminParams) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<DeviceInfo[]>>
  >(`/api/admin` + b6t + `/AccountDevice`, {
    admin_idx,
    admin_name,
    mobility_code,
    page,
    searchKey,
    sort,
    limit,
  });

  return response.data.result;
};

// 사용자 수정
export const putUserInfo = async ({
  address,
  address_detail,
  email,
  grade,
  idx,
  mobility_seq,
  name,
  phone,
  pw,
  permission,
  group_id,
}: AdminCrudType) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/admin` + b6t + `/member/patch`,
    {
      address,
      address_detail,
      email,
      grade,
      idx,
      mobility_seq,
      name,
      phone,
      pw,
      permission,
      group_id,
    }
  );
  return response.data;
};

// 사용자 등록
export const postUser = async ({
  address,
  address_detail,
  email,
  grade,
  mobility_seq,
  name,
  phone,
  pw,
  permission,
  id,
  group_id,
}: AdminCrudType) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/admin` + b6t + `/member`,
    {
      address,
      address_detail,
      email,
      grade,
      mobility_seq,
      name,
      phone,
      pw,
      permission,
      id,
      group_id,
    }
  );
  return response.data;
};

// 사용자 이미지 수정
export const putAdminMemberImage = async (payload: FormData) => {
  const response = await client.post<CustomAxiosType<string>>(
    `/api/admin` + b6t + `/member/image/patch`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// 사용자 이미지 삭제
export const deleteAdminMemberImage = async ({ idx }: DeleteAdmin) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/admin` + b6t + `/member/imgDel/patch`,
    {
      idx,
    }
  );
  return response.data;
};

// 사용자 담당기관명 조회
export const getUserGroup = async ({ group }: UserGroupParams) => {
  const response = await client.post<CustomAxiosType<UserGroup[]>>(
    `/api/admin` + b6t + `/member/userGroup/get`,
    {
      group,
    }
  );
  return response.data.result;
};

// 업데이트중인지 확인
export const getWebUpdate = async () => {
  const response = await client.post<CustomAxiosType<WebUpdate>>(
    `/api/admin` + b6t + `/webUpdate`
  );
  return response.data;
};

// 비밀번호 확인 - 나의 계정정보 모달 접근
export const postPwCheck = async ({ pw }: { pw: string }) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/login` + b6t + `/pw`,
    { pw }
  );

  return response.data;
};

export const getSystemSetting = async () => {
  const response = await client.post<CustomAxiosType<SystemSetting[]>>(
    `/api/admin` + b6t + `/system-setting/get`
  );

  return response.data;
};

// 패스워드 및 패스워드 실패 카운트 초기화
export const postResetPassword = async ({
  user_id,
}: {
  user_id: number;
}) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/admin` + b6t + `/reset-password`,
    { user_id }
  );

  return response.data;
};

// 관리자 사용자 하위 담당기관명 조회
export const getUserGroupSub = async () => {
  const response = await client.post<CustomAxiosType<UserGroup[]>>(
    `/api/admin` + b6t + `/member/userGroup/sub/get`
  );

  return response.data.result;
};
